import React from "react";
import { Switch } from "@/components/ui/switch";
import "./videobuy.css";

export const isUrl = (v) => /^https?:\/\/\S+$/i.test((v || "").trim());

export const inputCls =
  "w-full bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-[15px] text-white placeholder:text-slate-500 outline-none focus:border-[#FFB30F]/60 focus:ring-4 focus:ring-[#FFB30F]/10 transition-[border-color,box-shadow]";

export const EditorSection = ({ icon: Icon, title, desc, children, testid }) => (
  <div className="rounded-2xl border border-white/[0.08] bg-[#121824]/80 p-5 sm:p-6" data-testid={testid}>
    <div className="flex items-start gap-3 mb-5">
      <span className="w-9 h-9 rounded-xl bg-[#FFB30F]/10 text-[#FFB30F] flex items-center justify-center shrink-0">
        <Icon size={18} weight="duotone" />
      </span>
      <div className="min-w-0">
        <div className="font-display font-bold text-base sm:text-lg leading-tight">{title}</div>
        {desc && <div className="text-xs sm:text-sm text-slate-400 mt-0.5">{desc}</div>}
      </div>
    </div>
    <div className="space-y-4">{children}</div>
  </div>
);

export const Field = ({ label, hint, error, children }) => (
  <label className="block">
    <span className="block text-[11px] uppercase tracking-wider text-slate-400 mb-2 font-semibold">{label}</span>
    {children}
    {error ? <span className="block text-xs text-red-400 mt-1.5">{error}</span> : hint && <span className="block text-xs text-slate-500 mt-1.5">{hint}</span>}
  </label>
);

export const ToggleRow = ({ icon: Icon, title, desc, checked, onChange, testid }) => (
  <div className="flex items-center justify-between gap-4 rounded-xl border border-white/[0.08] bg-white/[0.02] px-4 py-3">
    <div className="min-w-0 flex items-start gap-3">
      {Icon && <Icon size={18} className="text-slate-400 mt-0.5 shrink-0" weight="duotone" />}
      <div className="min-w-0">
        <div className="text-sm font-semibold">{title}</div>
        {desc && <div className="text-xs text-slate-400 mt-0.5">{desc}</div>}
      </div>
    </div>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={testid} />
  </div>
);

export const PhonePreview = ({ children }) => (
  <div className="vb-phone mx-auto" style={{ width: "min(360px, 100%)" }} data-testid="editor-live-phone-preview">
    <div className="vb-phone-notch" />
    <div className="vb-phone-screen vb-root">
      <div className="px-4 pt-12 pb-8">{children}</div>
    </div>
  </div>
);
